'use client';
import { mergeRefs } from '@chakra-ui/hooks/use-merge-refs';
import { usePinInputContext, usePinInputDescendant } from './pin-input-context.mjs';

function usePinInputField(props = {}, ref = null) {
  const { getInputProps } = usePinInputContext();
  const { index, register } = usePinInputDescendant();
  return getInputProps({
    ...props,
    ref: mergeRefs(register, ref),
    index
  });
}

export { usePinInputField };
